/** @file Creates a skin, empty or as a copy of another skin's entries. */
import { z } from 'zod';
import { defineCommand } from '../defineCommand';
import { defineCreate } from '../_shared/defineCreate';

const create = defineCreate({
  domain: 'skin',
  kind: 'skin',
  description: "Create a skin (per slot: placeholder -> attachment); copyFrom (name or id) copies another skin's entries.",
  schema: z.object({ id: z.string().exactOptional(), name: z.string().min(1), copyFrom: z.string().min(1).exactOptional() }).strict(),
  build: (input) => ({ name: input.name, entries: [] }),
});

/** skin.create: the defineCreate factory, then a copy of copyFrom's entries into the new skin. */
export const command = defineCommand({
  ...create,
  apply(draft, input, ctx) {
    const source = input.copyFrom === undefined ? undefined : ctx.resolve('skin', input.copyFrom);
    create.apply(draft, input, ctx);
    const skin = draft.skins[ctx.created[input.name] ?? ''];
    const from = source === undefined ? undefined : draft.skins[source];
    if (skin && from) skin.entries = from.entries.map((e) => ({ slot: e.slot, placeholder: e.placeholder, attachment: e.attachment }));
  },
});
